module.exports = __webpack_public_path__ + "assets/imgs/event-banner/event-banner.svg";